import styled from 'styled-components';
import {Breakpoints} from "../../constants/Breakpoints";
import Colors from 'constants/Colors';
import {FontWeight, Text} from 'components/Text';

export const Container = styled.div `
  display: flex;
  align-items: center;
  
`; 

export const Subtitle = styled(Text)`
  font-size: 12px;
  margin-top: 0;
  
  font-weight: ${FontWeight.Medium};
  color: ${Colors.GRAY[6]};
  display: block;
  
  @media (min-width: ${Breakpoints.sm}) {
    font-size: 14px;
    margin-top: 15px;    
  }
  
  @media (min-width: ${Breakpoints.lg}) {
    font-size: 16px;
  }
`;

export const ContainerArrow = styled.div `
  margin-top: 0;
  margin-right: 5px;

  @media (min-width: ${Breakpoints.sm}) {
    margin-top: 14px;
    margin-right: 15px
  }
`;

export const ContainerArrowRight = styled.div`
  margin-top: 3.5px;
  margin-left: 5px;

  @media (min-width: ${Breakpoints.sm}) {
    margin-top: 14px;
    margin-left: 15px
  }
`

